import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 2rem;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, auto);
  row-gap: 2.5rem;
  column-gap: 1rem;

  input {
    width: 100%;
  }
`;

export const AddButton = styled.button`
  background: none;
  width: fit-content !important;
  margin-top: 1rem;
  color: var(--primary);
`;

export const ButtonWrapper = styled.div`
  padding: 2rem 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
